import { useState, useEffect } from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import IntroSection from "@/components/IntroSection";
import WhyMattersSection from "@/components/WhyMattersSection";
import HowIWorkSection from "@/components/HowIWorkSection";
import CoreAreasSection from "@/components/CoreAreasSection";
import WomenSection from "@/components/WomenSection";
import FormatsSection from "@/components/FormatsSection";
import PhilosophySection from "@/components/PhilosophySection";
import AboutSection from "@/components/AboutSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function LandingPage() {
  const [isVisible, setIsVisible] = useState({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible((prev) => ({ ...prev, [entry.target.id]: true }));
          }
        });
      },
      { threshold: 0.1 }
    );

    const sections = document.querySelectorAll("section[id]");
    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-[#F9F6F0]" data-testid="landing-page">
      <Header />
      <main>
        <HeroSection />
        <IntroSection isVisible={isVisible["intro"]} />
        <WhyMattersSection isVisible={isVisible["why-matters"]} />
        <HowIWorkSection isVisible={isVisible["how-i-work"]} />
        <CoreAreasSection isVisible={isVisible["core-areas"]} />
        <WomenSection isVisible={isVisible["women-only"]} />
        <FormatsSection isVisible={isVisible["formats"]} />
        <PhilosophySection isVisible={isVisible["philosophy"]} />
        <AboutSection isVisible={isVisible["about"]} />
        <ContactSection isVisible={isVisible["contact"]} />
      </main>
      <Footer />
    </div>
  );
}
